import {
  useExhibitors,
  useProducts,
} from '@bottlebooks/gatsby-theme-event/src/components/SiteSearch/useEventData';
import { useEnrichedFavorites } from '@bottlebooks/gatsby-plugin-bookmarks/src';

export interface ProductListItem {
  type: 'product';
  id: string;
  isComplete?: boolean;
}
export interface ExhibitorListItem {
  type: 'registration';
  id: string;
  isComplete?: boolean;
}
export interface List {
  listId: string;
  name: string;
  description?: string;
  items: (ProductListItem | ExhibitorListItem)[];
}

export interface ListProduct
  extends Extract<
    NonNullable<ReturnType<typeof useEnrichedFavorites>>[number],
    { type: 'product' }
  > {}

export interface ListExhibitor
  extends Extract<
    NonNullable<ReturnType<typeof useEnrichedFavorites>>[number],
    { type: 'registration' }
  > {}

export function ListProvider({ children }) {
  return children;
}

export function useList(listId: string): List {
  const { all } = useLists();
  return (
    all.find((list) => list.listId === listId) || {
      listId,
      name: `List ${listId}`,
      items: [],
    }
  );
}

export function useEnrichedLists() {
  const lists = useLists();
  const products = useProducts();
  const exhibitors = useExhibitors();
  return (listId: string) => {
    const list = lists.findById(listId);
    if (!list) return null;
    if (!list.items) return list;
    return {
      ...list,
      items: list.items.map((item) => {
        switch (item.type) {
          case 'product': {
            return {
              ...item,
              ...products.findById(item.id),
            };
          }
          case 'registration':
          default: {
            return {
              ...item,
              ...exhibitors.findById(item.id),
              exhibitorId: item.id,
            };
          }
        }
      }),
    };
  };
}

export function useLists() {
  const all: List[] = [
    { listId: '1', name: 'List 1', items: [] },
    {
      listId: '2sdfsdg',
      name: 'My Tasting List – flight 2',
      items: [
        { id: '61b36c5915d21c0f18cb0350', type: 'product' },
        { id: '5e1f6811f5daf879e5403729', type: 'registration' },
      ],
    },
  ];
  return {
    all,
    findById: (listId: string) => all.find((list) => list.listId === listId),
  };
}
